// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /ocorrencias/save
 *
 * Creates a new occurrence/note for a given owner entity.
 */
import { registerContract } from './validate'

export interface Ocorrencias_SaveInput {
owner: string
ownerID: number
content: string
}

registerContract('Ocorrencias_SaveInput', {
  owner:   { type: 'string',  required: true },
  ownerID: { type: 'number',  required: true },
  content: { type: 'string',  required: true },
})
